/**
 * Transform an API Passenger object to a Passenger
 *
 * @param passenger The API Passenger object
 * @returns Passenger
 */
export function transformPassenger(
    passenger: ApiSchema['Passenger'],
    stripHiddenReductionCards: boolean = false,
): Passenger {
    let keycard: Keycard | undefined;
    if (passenger.fulfillmentOption?.type && passenger.fulfillmentPassReference?.type) {
        keycard = {
            media: passenger.fulfillmentOption?.media,
            type: passenger.fulfillmentOption?.type,
            reference: passenger.fulfillmentPassReference.reference || undefined,
            postalCode: passenger.fulfillmentPassReference.postalCode || undefined,
            valid: false,
        };
    }
    else if (passenger.fulfillmentOption?.type) {
        keycard = {
            media: passenger.fulfillmentOption?.media,
            type: passenger.fulfillmentOption?.type,
            reference: undefined,
            postalCode: undefined,
            valid: true,
        };
    }

    return {
        id: passenger.id,
        ref: passenger.externalRef ?? '',
        firstName: passenger.detail?.firstName ?? '',
        lastName: passenger.detail?.lastName ?? '',
        dateOfBirth: zurichDate(passenger.dateOfBirth),
        keycard,
        reductionCards: passenger.cards
            ?.filter(c => c.type === 'REDUCTION_CARD')
            ?.filter(c => !stripHiddenReductionCards || (c.code !== 'JB_SKI_PASS' && c.code !== 'JB_SWP_PASS' && c.code !== 'JUNGFRAU_TRAVEL_PASS'))
            .map<ReductionCard>(c => ({
                type: 'REDUCTION_CARD',
                code: c.code ?? '',
                name: '',
            })) ?? [],

        photo: passenger.detail?.photo,
        address: passenger.detail?.address?.street
            ? {
                    street: passenger.detail.address.street ?? '',
                    postCode: passenger.detail.address.postCode ?? '',
                    city: passenger.detail.address.city ?? '',
                    countryCode: passenger.detail.address.countryCode ?? '',
                }
            : undefined,

    };
}
